module.exports = __webpack_public_path__ + "img/outlookicon.ecb3ad6f.png";